import './BackdropPanel.css';
import GradientText from '../GradientText/GradientText';

export function BackdropPanelContent({
  children,
  className = '',
}) {
  const classes = ['BackdropPanel__content', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
}

export default function BackdropPanel({
  title,
  total,
  icon,
  children,
  className = '',
}) {
  const classes = ['BackdropPanel', className].filter(Boolean).join(' ');
  const hasMetrics = Boolean(title) || (total !== undefined && total !== null);
  const hasBackdrop = hasMetrics || icon;

  return (
    <div className={classes}>
      <BackdropPanelContent>
        {hasBackdrop ? (
          <div className="BackdropPanel__backdrop" aria-hidden="true">
            {hasMetrics ? (
              <div className="BackdropPanel__metrics">
                {title ? (
                  <GradientText className="BackdropPanel__title" text={title} showGlow />
                ) : null}
                {total !== undefined && total !== null ? (
                  <GradientText className="BackdropPanel__total" text={`${total}`} />
                ) : null}
              </div>
            ) : null}
            {icon ? <div className="BackdropPanel__icon">{icon}</div> : null}
          </div>
        ) : null}
        <div className="BackdropPanel__children">{children}</div>
      </BackdropPanelContent>
    </div>
  );
}
